module.exports = "<img src=\"../../../assets/images/badge.png\" id=\"logo\" height=\"65px\" width=\"65px\">\n"